
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as codice_authenticatorg2sNIdjlqTUm0dREsFZQTKEx51c3J_PulJyL4usSpMQMeta } from "/opt/suncore/build/20261104T102900Z-fec39489/app/pages/verifica_dispositivo/codice_authenticator.vue?macro=true";
import { default as codice_email16dWf9Sh8bT8DRZKdiDnL_UhCHKQ2qi2uEPcP7tyXdUMeta } from "/opt/suncore/build/20261104T102900Z-fec39489/app/pages/verifica_dispositivo/codice_email.vue?macro=true";
import { default as assistenzadxQsC5ntbWbqzlRt2Uy6_HvnPpv7oRPMIMKoq3n25gEMeta } from "/opt/suncore/build/20261104T102900Z-fec39489/app/pages/assistenza.vue?macro=true";
import { default as impostazioniLFcMXV5oMzT3TrmwAehB574EotdCcivpdyroeEX2mAAMeta } from "/opt/suncore/build/20261104T102900Z-fec39489/app/pages/impostazioni.vue?macro=true";
import { default as loginqfnLJ7wun4vilG9_0SbEoDEMsWUiPY9TApWoY1U_Uw4Meta } from "/opt/suncore/build/20261104T102900Z-fec39489/app/pages/login.vue?macro=true";
import { default as notificheSiA15N_zS_O1WQML8FZgiVKauadefcJyAqAjktaCW7MMeta } from "/opt/suncore/build/20261104T102900Z-fec39489/app/pages/notifiche.vue?macro=true";
import { default as privacyaQBHMnYWu94UiXsVeWGD6JHYhCaMaxpzqs39U8oo7O8Meta } from "/opt/suncore/build/20261104T102900Z-fec39489/app/pages/privacy.vue?macro=true";
import { default as profiloCCMnlqEm6wPZBC8sbZFukXXjBA0qJnJJjo9QlmkrFIkMeta } from "/opt/suncore/build/20261104T102900Z-fec39489/app/pages/profilo.vue?macro=true";
import { default as recupera_45passwordwDK9XGlBc3fNa_gybYx2kTh5eN9_nyEmMj2i3JM6VM4Meta } from "/opt/suncore/build/20261104T102900Z-fec39489/app/pages/recupera-password.vue?macro=true";
export default [
  {
    name: "anagrafiche-allarmi",
    path: "/anagrafiche/allarmi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/anagrafiche/allarmi.vue")
  },
  {
    name: "anagrafiche-dispositivi",
    path: "/anagrafiche/dispositivi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/anagrafiche/dispositivi.vue")
  },
  {
    name: "anagrafiche-firmware",
    path: "/anagrafiche/firmware",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/anagrafiche/firmware.vue")
  },
  {
    name: "anagrafiche-impianti",
    path: "/anagrafiche/impianti",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/anagrafiche/impianti.vue")
  },
  {
    name: "anagrafiche-modelli_inverters",
    path: "/anagrafiche/modelli_inverters",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/anagrafiche/modelli_inverters.vue")
  },
  {
    name: "anagrafiche-utenti",
    path: "/anagrafiche/utenti",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/anagrafiche/utenti.vue")
  },
  {
    name: "anagrafiche-utenti_api",
    path: "/anagrafiche/utenti_api",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/anagrafiche/utenti_api.vue")
  },
  {
    name: "monitoraggio-firmware",
    path: "/monitoraggio/firmware",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/monitoraggio/firmware.vue")
  },
  {
    name: "monitoraggio-impianti",
    path: "/monitoraggio/impianti",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/monitoraggio/impianti.vue")
  },
  {
    name: "storico-allarmi",
    path: "/storico/allarmi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/storico/allarmi.vue")
  },
  {
    name: "storico-batteria",
    path: "/storico/batteria",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/storico/batteria.vue")
  },
  {
    name: "storico-comandi",
    path: "/storico/comandi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/storico/comandi.vue")
  },
  {
    name: "storico-inclinazioni",
    path: "/storico/inclinazioni",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/storico/inclinazioni.vue")
  },
  {
    name: "storico-meteo",
    path: "/storico/meteo",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/storico/meteo.vue")
  },
  {
    name: "storico-produzione",
    path: "/storico/produzione",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/storico/produzione.vue")
  },
  {
    name: "strumenti-archivio",
    path: "/strumenti/archivio",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/strumenti/archivio.vue")
  },
  {
    name: "strumenti-backup",
    path: "/strumenti/backup",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/strumenti/backup.vue")
  },
  {
    name: "strumenti-database",
    path: "/strumenti/database",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/strumenti/database.vue")
  },
  {
    name: "strumenti-log_api",
    path: "/strumenti/log_api",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/strumenti/log_api.vue")
  },
  {
    name: "strumenti-log_attivita",
    path: "/strumenti/log_attivita",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/strumenti/log_attivita.vue")
  },
  {
    name: "strumenti-log_comandi",
    path: "/strumenti/log_comandi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/strumenti/log_comandi.vue")
  },
  {
    name: "strumenti-log_eventi",
    path: "/strumenti/log_eventi",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/strumenti/log_eventi.vue")
  },
  {
    name: "verifica_dispositivo-codice_authenticator",
    path: "/verifica_dispositivo/codice_authenticator",
    meta: codice_authenticatorg2sNIdjlqTUm0dREsFZQTKEx51c3J_PulJyL4usSpMQMeta || {},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/verifica_dispositivo/codice_authenticator.vue")
  },
  {
    name: "verifica_dispositivo-codice_email",
    path: "/verifica_dispositivo/codice_email",
    meta: codice_email16dWf9Sh8bT8DRZKdiDnL_UhCHKQ2qi2uEPcP7tyXdUMeta || {},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/verifica_dispositivo/codice_email.vue")
  },
  {
    name: "impianti-id",
    path: "/impianti/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/impianti/[id].vue")
  },
  {
    name: "assistenza",
    path: "/assistenza",
    meta: { ...(assistenzadxQsC5ntbWbqzlRt2Uy6_HvnPpv7oRPMIMKoq3n25gEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/assistenza.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":["auth"]},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/dashboard.vue")
  },
  {
    name: "impostazioni",
    path: "/impostazioni",
    meta: { ...(impostazioniLFcMXV5oMzT3TrmwAehB574EotdCcivpdyroeEX2mAAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/impostazioni.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginqfnLJ7wun4vilG9_0SbEoDEMsWUiPY9TApWoY1U_Uw4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/login.vue")
  },
  {
    name: "notifiche",
    path: "/notifiche",
    meta: { ...(notificheSiA15N_zS_O1WQML8FZgiVKauadefcJyAqAjktaCW7MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/notifiche.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyaQBHMnYWu94UiXsVeWGD6JHYhCaMaxpzqs39U8oo7O8Meta || {},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/privacy.vue")
  },
  {
    name: "profilo",
    path: "/profilo",
    meta: profiloCCMnlqEm6wPZBC8sbZFukXXjBA0qJnJJjo9QlmkrFIkMeta || {},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/profilo.vue")
  },
  {
    name: "recupera-password",
    path: "/recupera-password",
    meta: recupera_45passwordwDK9XGlBc3fNa_gybYx2kTh5eN9_nyEmMj2i3JM6VM4Meta || {},
    component: () => import("/opt/suncore/build/20261104T102900Z-fec39489/app/pages/recupera-password.vue")
  }
]